import L from "leaflet";
import { api } from "@/api";

const SAT = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
const OSM = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

export async function loadMapConfig() {
  try { const { data } = await api.get("/settings/map"); return data; }
  catch { return { mode: "osm", static_image: null, bounds: null }; }
}

// Returns a Leaflet layer (not yet added). Caller does .addTo(map).
export function makeBaseLayer(cfg, satellite) {
  if (satellite) return L.tileLayer(SAT, { maxZoom: 19 });
  if (cfg && cfg.mode === "static" && cfg.static_image && cfg.bounds) {
    return L.imageOverlay(cfg.static_image, cfg.bounds);
  }
  return L.tileLayer(OSM, { maxZoom: 19 });
}
